import React from "react";
import { Body, Heading } from "../../atoms";
export default function SimpleCardRow(param) {
    var title = param.title, description = param.description, className = param.className;
    return /*#__PURE__*/ React.createElement("article", {
        className: className
    }, /*#__PURE__*/ React.createElement("div", {
        className: "bg-bg-base rounded-xl p-6 md:p-7"
    }, /*#__PURE__*/ React.createElement(Heading, {
        as: "h4",
        variant: "h4"
    }, title), !!description && /*#__PURE__*/ React.createElement(Body, {
        className: "prose mt-5"
    }, description)));
}

//# sourceMappingURL=SimpleCardRow.js.map